import { render, staticRenderFns } from "./Outlets.vue?vue&type=template&id=27f67f52&scoped=true&"
import script from "./Outlets.vue?vue&type=script&lang=ts&"
export * from "./Outlets.vue?vue&type=script&lang=ts&"
import style0 from "./Outlets.vue?vue&type=style&index=0&id=27f67f52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f67f52",
  null
  
)

export default component.exports